import { MAX_MARKER_LABEL_LENGTH } from './sketch-tools';

export interface EvidenceMarker {
  readonly number: number;
  readonly label: string;
}

export const FIRST_MARKER_NUMBER = 1;

export function nextMarkerNumber(existing: readonly number[]): number {
  let highest = FIRST_MARKER_NUMBER - 1;
  for (const n of existing) {
    if (Number.isInteger(n) && n > highest) {
      highest = n;
    }
  }
  return highest + 1;
}

export function normalizeMarkerLabel(label: string | null | undefined): string {
  return (label || '').replace(/\s+/g, ' ').trim().slice(0, MAX_MARKER_LABEL_LENGTH);
}

export function buildLegend(markers: readonly EvidenceMarker[]): EvidenceMarker[] {
  const byNumber = new Map<number, string>();
  for (const marker of markers) {
    if (!Number.isInteger(marker.number) || marker.number < FIRST_MARKER_NUMBER) {
      continue;
    }
    const label = normalizeMarkerLabel(marker.label);
    const current = byNumber.get(marker.number);
    byNumber.set(marker.number, current ? (label ? `${current}; ${label}` : current) : label);
  }
  return Array.from(byNumber.entries())
    .sort((a, b) => a[0] - b[0])
    .map(([number, label]) => ({ number, label }));
}

export function describeMarker(marker: EvidenceMarker): string {
  return marker.label ? `${marker.number}. ${marker.label}` : `${marker.number}. (no description)`;
}
